/**
 * Telegram push delivery (#52-#55).
 *
 * #53 and #55 answer with the full #52 payload, so the Settings tab replaces its cache instead of
 * refetching — the same contract the Scrapers and Notion tabs use.
 */

import type { TelegramStateResponse } from '@lw/shared';
import { apiJson, apiVoid } from './client';

export function getTelegram(signal?: AbortSignal): Promise<TelegramStateResponse> {
  return apiJson<TelegramStateResponse>('/telegram', { ...(signal ? { signal } : {}) });
}

export function connectTelegram(token: string): Promise<TelegramStateResponse> {
  return apiJson<TelegramStateResponse>('/telegram/connect', {
    method: 'POST',
    body: { token },
  });
}

export function disconnectTelegram(): Promise<void> {
  return apiVoid('/telegram/disconnect', { method: 'POST' });
}

export function testTelegram(): Promise<TelegramStateResponse> {
  return apiJson<TelegramStateResponse>('/telegram/test', { method: 'POST' });
}
